// @flow
import * as React from 'react'
import { withRouter } from 'react-router-dom'
import type { MapType } from 'catena/er2_map_userlayers/js/reducers/map'
import FicusControls from './ficus_controls'
import TransimControls from './transim_controls'
import ficusStyles from '../styles'
import type { AnalyzeFrameworkBarType } from '../reducers/analyze_framework_bar'
import type { SelectFrameworkBarType } from '../reducers/select_framework_bar'
import type { AnalysisPanelType } from '../reducers/analysis_panel'

type Props = {
    addBookmark: Function,
    analysisPanel: AnalysisPanelType,
    clearFramework: Function,
    config: AnalyzeFrameworkBarType,
    ficus: SelectFrameworkBarType,
    map: MapType,
    modes: string[],
    removeMapLocations: Function,
    setAnalyzeMode: Function,
    setFicusConfig: Function,
    setFicusData: Function,
    setTransimConfig: Function,
    theme: ficusStyles,
    updateIterationOrder: Function,
}

function AnalyzeFrameworkBar(props: Props) {
    const rootClassNames = [props.theme.controlBar]

    let loading
    let loadingScale = '20%'
    if (props.ficus.fetchingFicusData) {
        loading = (
            <div style={{ textAlign: 'center', width: '100%' }}>
                <img
                    alt="loading frameworks"
                    style={{ maxWidth: loadingScale, height: 'auto' }}
                    src="/static/er2_ficus/img/dualring.gif"
                />
            </div>
        )
    }
    if (props.ficus.ficusData.themeType === 'raster') {
        return (
            <div className={rootClassNames.join(' ')}>
                <div className={props.theme.controlBarTop}>
                    <FicusControls
                        addBookmark={props.addBookmark}
                        analysisPanel={props.analysisPanel}
                        config={props.config}
                        ficus={props.ficus}
                        modes={props.modes}
                        removeMapLocations={props.removeMapLocations}
                        setAnalyzeMode={props.setAnalyzeMode}
                        setConfig={props.setFicusConfig}
                        setFicusData={props.setFicusData}
                        theme={props.theme}
                        updateIterationOrder={props.updateIterationOrder}
                    />
                    {loading}
                </div>
            </div>
        )
    } else if (props.ficus.ficusData.themeType === 'vector') {
        return (
            <div className={rootClassNames.join(' ')}>
                <div className={props.theme.controlBarTop}>
                    <TransimControls
                        addBookmark={props.addBookmark}
                        config={props.config}
                        ficus={props.ficus}
                        map={props.map}
                        removeMapLocations={props.removeMapLocations}
                        setAnalyzeMode={props.setAnalyzeMode}
                        setConfig={props.setFicusConfig}
                        theme={props.theme}
                    />
                    {loading}
                </div>
            </div>
        )
    }

    loadingScale = '50%'
    return (
        <div style={{ textAlign: 'center', marginTop: '30px', marginLeft: '40%', width: '100%' }}>
            <img
                alt="loading frameworks"
                style={{ maxWidth: loadingScale, height: 'auto' }}
                src="/static/er2_ficus/img/dualring.gif"
            />
        </div>
    )
}

export default withRouter(AnalyzeFrameworkBar)
